import React from 'react';
import Moment from 'moment';
import { t } from '../../../../i18n';
import CustomDataTable from '../../shared/CustomDataTable';
import { formatDate } from '../../normalizer';

/**
 * Requested Trades Table component using CustomDataTable
 */
const RequestedTradesTable = ({ sales }) => {
  const className = 'requested-trades-table';
  const columns = [
    {
      key: 'date',
      label: 'Envio',
      sortKey: 'date',
      render: (_v, item) => formatDate(item.date),
    },
    {
      key: 'completed_date',
      label: 'Resposta',
      sortKey: 'completed_date',
      render: (_v, item) => formatDate(item.completed_date),
    },
    {
      key: 'user_solicited',
      label: 'Utilizador',
      sortKey: 'user_solicited',
    },
    {
      key: 'description',
      label: 'Descrição',
      sortKey: 'description',
    },
    {
      key: 'status',
      label: 'Estado',
      sortKey: 'status',
      render: (_v, item) => (
        <span className={`${className}__cell--status ${className}__cell--status--${item.status}`}>
          {t(`trades.${item.status}`)}
        </span>
      ),
    },
  ];

  const sortFn = (data, sort) => {
    return [...data].sort((a, b) => {
      const multiplier = sort.direction === 'asc' ? 1 : -1;
      if (sort.key === 'date' || sort.key === 'completed_date') {
        const dateA = a[sort.key] ? new Date(a[sort.key]) : new Date(0);
        const dateB = b[sort.key] ? new Date(b[sort.key]) : new Date(0);
        return (dateA - dateB) * multiplier;
      }
      const valA = (a[sort.key] || '').toString().toLowerCase();
      const valB = (b[sort.key] || '').toString().toLowerCase();
      return valA.localeCompare(valB) * multiplier;
    });
  };

  const renderRow = (sale, index, className) => {
    return (
      <tr
        key={sale.id || index}
        className={`data-table__row ${className}__row`}
      >
        <td className={`data-table__cell ${className}__cell`}>
          {formatDate(sale.date)}
        </td>
        <td className={`data-table__cell ${className}__cell`}>
          {formatDate(sale.completed_date)}
        </td>
        <td className={`data-table__cell ${className}__cell`}>
          {sale.user_solicited}
        </td>
        <td className={`data-table__cell ${className}__cell`}>
          {sale.description}
        </td>
        <td className={`data-table__cell ${className}__cell ${sale.status}`}>
          <span className={`${className}__cell--status ${className}__cell--status--${sale.status}`}>
            {t(`trades.${sale.status}`)}
          </span>
        </td>
      </tr>
    );
  };

  return (
    <CustomDataTable
      className="requested-trades-table"
      columns={columns}
      data={sales}
      renderRow={renderRow}
      rowKey={(item) => item.id}
      defaultSort={{ key: 'date', direction: 'desc' }}
      sortFn={sortFn}
      emptyMessage="Não realizou nenhuma trocas de contratos."
    />
  );
};

export default RequestedTradesTable;

